import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-content" }
const _hoisted_2 = { class: "user-list" }
const _hoisted_3 = { class: "user-item" }
const _hoisted_4 = { class: "buttons" }

import { UserApproval } from "@/services/entities/Approval/UserApproval";

import { VueFinalModal } from "vue-final-modal";


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminLockModal',
  props: {
    users: {}
  },
  emits: ["close", "lock", "unlock"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

function hasOnlyUnlockedUsers(): boolean {
  return props.users.every(u => !u.monthlyApprovalItem?.isLocked);
}

function hasOnlyLockedUsers(): boolean {
  return props.users.every(u => u.monthlyApprovalItem?.isLocked);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VueFinalModal), {
    class: "comment-modal",
    "content-class": "modal-content",
    "content-transition": "vfm-slide-up"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", null, "Admin Lock/Unlock selected and Approved (" + _toDisplayString(props.users.length) + ") " + _toDisplayString(props.users.length == 1 ? 'user' : 'users'), 1),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.users, (usr) => {
            return (_openBlock(), _createElementBlock("div", {
              key: usr.userItem.id
            }, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(usr.userItem.fullName) + " (" + _toDisplayString(usr.userItem.email) + ")", 1)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = () => emit('close'))
          }, "Cancel"),
          (!hasOnlyLockedUsers())
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "accent",
                onClick: _cache[1] || (_cache[1] = () => emit('lock'))
              }, "Lock"))
            : _createCommentVNode("", true),
          (!hasOnlyUnlockedUsers())
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "accent",
                onClick: _cache[2] || (_cache[2] = () => emit('unlock'))
              }, "Unlock"))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})